/**
 * Registry for the pages rendered by `app/pages/blog/[slug].vue`.
 * Every `slug`/`title`/`excerpt`/`content` string is an i18n key, resolved per locale.
 *
 * `relatedContentPageIds` — ids from `app/lib/content-pages`, most relevant first.
 * They render as the related-links section under the article, the only path from the
 * blog to the commercial pages. Two invariants, both covered by
 * `related-content-links.spec.js`: every post links to at least one content page, and
 * every content page is linked from at least one post.
 */
export const blogPostsData = [
  {
    id: 'share_photos_with_group',
    source: 'plan',
    relatedContentPageIds: ['vacation', 'family_gatherings', 'birthday'],
    slug: 'blog.posts.share_photos_with_group.slug',
    title: 'blog.posts.share_photos_with_group.title',
    titleShort: 'blog.posts.share_photos_with_group.title_short',
    excerpt: 'blog.posts.share_photos_with_group.excerpt',
    content: 'blog.posts.share_photos_with_group.content',
    author: 'Meine Nieuwland',
    date: '2026-10-23',
    readingTime: 12,
    image: '/images/blog/fotos-delen-met-groep-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'wedding_qr_code_guide',
    source: 'plan',
    relatedContentPageIds: ['wedding'],
    slug: 'blog.posts.wedding_qr_code_guide.slug',
    title: 'blog.posts.wedding_qr_code_guide.title',
    titleShort: 'blog.posts.wedding_qr_code_guide.title_short',
    excerpt: 'blog.posts.wedding_qr_code_guide.excerpt',
    content: 'blog.posts.wedding_qr_code_guide.content',
    author: 'Meine Nieuwland',
    date: '2026-10-23',
    readingTime: 12,
    image: '/images/blog/qr-code-bruiloft-fotos-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'iphone_shared_album',
    source: 'plan',
    relatedContentPageIds: ['family_gatherings', 'wedding', 'birthday'],
    slug: 'blog.posts.iphone_shared_album.slug',
    title: 'blog.posts.iphone_shared_album.title',
    titleShort: 'blog.posts.iphone_shared_album.title_short',
    excerpt: 'blog.posts.iphone_shared_album.excerpt',
    content: 'blog.posts.iphone_shared_album.content',
    author: 'Martijn de Vries',
    date: '2026-10-23',
    readingTime: 8,
    image: '/images/blog/gedeeld-album-iphone-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'share_photos_via_link',
    source: 'plan',
    relatedContentPageIds: ['vacation', 'family_gatherings', 'birthday'],
    slug: 'blog.posts.share_photos_via_link.slug',
    title: 'blog.posts.share_photos_via_link.title',
    titleShort: 'blog.posts.share_photos_via_link.title_short',
    excerpt: 'blog.posts.share_photos_via_link.excerpt',
    content: 'blog.posts.share_photos_via_link.content',
    author: 'Meine Nieuwland',
    date: '2026-10-23',
    readingTime: 10,
    image: '/images/blog/fotos-delen-via-link-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'best_wedding_photo_apps',
    source: 'plan',
    relatedContentPageIds: ['wedding'],
    slug: 'blog.posts.best_wedding_photo_apps.slug',
    title: 'blog.posts.best_wedding_photo_apps.title',
    titleShort: 'blog.posts.best_wedding_photo_apps.title_short',
    excerpt: 'blog.posts.best_wedding_photo_apps.excerpt',
    content: 'blog.posts.best_wedding_photo_apps.content',
    author: 'Meine Nieuwland',
    date: '2026-10-16',
    readingTime: 10,
    image: '/images/blog/beste-app-fotos-delen-bruiloft-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'guestbook_feature_announcement',
    relatedContentPageIds: ['wedding', 'wedding_anniversary', 'birthday'],
    slug: 'blog.posts.guestbook_feature_announcement.slug',
    title: 'blog.posts.guestbook_feature_announcement.title',
    titleShort: 'blog.posts.guestbook_feature_announcement.title_short',
    excerpt: 'blog.posts.guestbook_feature_announcement.excerpt',
    content: 'blog.posts.guestbook_feature_announcement.content',
    author: 'Martijn de Vries',
    date: '2026-10-12',
    readingTime: 5,
    image: '/images/blog/gastenboek-geschreven-en-ingesproken-berichten-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'remove_unwanted_event_photos',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'company_party', 'family_gatherings'],
    slug: 'blog.posts.remove_unwanted_event_photos.slug',
    title: 'blog.posts.remove_unwanted_event_photos.title',
    titleShort: 'blog.posts.remove_unwanted_event_photos.title_short',
    excerpt: 'blog.posts.remove_unwanted_event_photos.excerpt',
    content: 'blog.posts.remove_unwanted_event_photos.content',
    author: 'Meine Nieuwland',
    date: '2026-09-26',
    readingTime: 8,
    image: '/images/blog/ongewenste-fotos-achteraf-verwijderen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'media_availability_after_event',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'company_party', 'family_gatherings'],
    slug: 'blog.posts.media_availability_after_event.slug',
    title: 'blog.posts.media_availability_after_event.title',
    titleShort: 'blog.posts.media_availability_after_event.title_short',
    excerpt: 'blog.posts.media_availability_after_event.excerpt',
    content: 'blog.posts.media_availability_after_event.content',
    author: 'Meine Nieuwland',
    date: '2026-09-20',
    readingTime: 9,
    image: '/images/blog/hoe-lang-blijft-media-beschikbaar-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'digital_wedding_guestbook_steps',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary'],
    slug: 'blog.posts.digital_wedding_guestbook_steps.slug',
    title: 'blog.posts.digital_wedding_guestbook_steps.title',
    titleShort: 'blog.posts.digital_wedding_guestbook_steps.title_short',
    excerpt: 'blog.posts.digital_wedding_guestbook_steps.excerpt',
    content: 'blog.posts.digital_wedding_guestbook_steps.content',
    author: 'Meine Nieuwland',
    date: '2026-09-16',
    readingTime: 9,
    image: '/images/blog/stappen-digitaal-bruiloftsgastenboek-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'best_party_gallery_features',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.best_party_gallery_features.slug',
    title: 'blog.posts.best_party_gallery_features.title',
    titleShort: 'blog.posts.best_party_gallery_features.title_short',
    excerpt: 'blog.posts.best_party_gallery_features.excerpt',
    content: 'blog.posts.best_party_gallery_features.content',
    author: 'Meine Nieuwland',
    date: '2026-09-15',
    readingTime: 10,
    image: '/images/blog/beste-functies-voor-feestgalerijen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'start_video_collection_event_link',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.start_video_collection_event_link.slug',
    title: 'blog.posts.start_video_collection_event_link.title',
    titleShort: 'blog.posts.start_video_collection_event_link.title_short',
    excerpt: 'blog.posts.start_video_collection_event_link.excerpt',
    content: 'blog.posts.start_video_collection_event_link.content',
    author: 'Meine Nieuwland',
    date: '2026-09-13',
    readingTime: 9,
    image: '/images/blog/videoverzameling-starten-met-evenementlink-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'share_baby_photos_with_family',
    relatedContentPageIds: ['family_gatherings', 'birthday', 'vacation'],
    slug: 'blog.posts.share_baby_photos_with_family.slug',
    title: 'blog.posts.share_baby_photos_with_family.title',
    titleShort: 'blog.posts.share_baby_photos_with_family.title_short',
    excerpt: 'blog.posts.share_baby_photos_with_family.excerpt',
    content: 'blog.posts.share_baby_photos_with_family.content',
    author: 'Martijn de Vries',
    date: '2026-09-12',
    readingTime: 6,
    image: '/images/blog/babyfotos-delen-met-familie-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'anonymous_guest_photo_upload',
    source: 'soro',
    relatedContentPageIds: ['company_party', 'wedding', 'family_gatherings'],
    slug: 'blog.posts.anonymous_guest_photo_upload.slug',
    title: 'blog.posts.anonymous_guest_photo_upload.title',
    titleShort: 'blog.posts.anonymous_guest_photo_upload.title_short',
    excerpt: 'blog.posts.anonymous_guest_photo_upload.excerpt',
    content: 'blog.posts.anonymous_guest_photo_upload.content',
    author: 'Martijn de Vries',
    date: '2026-09-07',
    readingTime: 10,
    image: '/images/blog/kunnen-gasten-anoniem-fotos-uploaden-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'collect_videos_without_account',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.collect_videos_without_account.slug',
    title: 'blog.posts.collect_videos_without_account.title',
    titleShort: 'blog.posts.collect_videos_without_account.title_short',
    excerpt: 'blog.posts.collect_videos_without_account.excerpt',
    content: 'blog.posts.collect_videos_without_account.content',
    author: 'Martijn de Vries',
    date: '2026-09-07',
    readingTime: 8,
    image: '/images/blog/videos-verzamelen-zonder-account-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'digital_photo_wall_party',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.digital_photo_wall_party.slug',
    title: 'blog.posts.digital_photo_wall_party.title',
    titleShort: 'blog.posts.digital_photo_wall_party.title_short',
    excerpt: 'blog.posts.digital_photo_wall_party.excerpt',
    content: 'blog.posts.digital_photo_wall_party.content',
    author: 'Meine Nieuwland',
    date: '2026-08-31',
    readingTime: 9,
    image: '/images/blog/digitale-fotomuur-tonen-op-feest-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'where_party_videos_stored',
    relatedContentPageIds: ['birthday', 'wedding', 'company_party'],
    slug: 'blog.posts.where_party_videos_stored.slug',
    title: 'blog.posts.where_party_videos_stored.title',
    titleShort: 'blog.posts.where_party_videos_stored.title_short',
    excerpt: 'blog.posts.where_party_videos_stored.excerpt',
    content: 'blog.posts.where_party_videos_stored.content',
    author: 'Meine Nieuwland',
    date: '2026-08-29',
    readingTime: 8,
    image: '/images/blog/waar-worden-feestvideos-opgeslagen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'best_company_party_gallery',
    relatedContentPageIds: ['company_party', 'christmas', 'new_years_eve'],
    slug: 'blog.posts.best_company_party_gallery.slug',
    title: 'blog.posts.best_company_party_gallery.title',
    titleShort: 'blog.posts.best_company_party_gallery.title_short',
    excerpt: 'blog.posts.best_company_party_gallery.excerpt',
    content: 'blog.posts.best_company_party_gallery.content',
    author: 'Meine Nieuwland',
    date: '2026-08-27',
    readingTime: 8,
    image: '/images/blog/beste-galerij-voor-bedrijfsfeest-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'create_event_page_for_guests',
    source: 'soro',
    relatedContentPageIds: ['birthday', 'wedding', 'company_party'],
    slug: 'blog.posts.create_event_page_for_guests.slug',
    title: 'blog.posts.create_event_page_for_guests.title',
    titleShort: 'blog.posts.create_event_page_for_guests.title_short',
    excerpt: 'blog.posts.create_event_page_for_guests.excerpt',
    content: 'blog.posts.create_event_page_for_guests.content',
    author: 'Meine Nieuwland',
    date: '2026-08-25',
    readingTime: 9,
    image: '/images/blog/eventpagina-maken-voor-gasten-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'wedding_gallery_planning_guide',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary'],
    slug: 'blog.posts.wedding_gallery_planning_guide.slug',
    title: 'blog.posts.wedding_gallery_planning_guide.title',
    titleShort: 'blog.posts.wedding_gallery_planning_guide.title_short',
    excerpt: 'blog.posts.wedding_gallery_planning_guide.excerpt',
    content: 'blog.posts.wedding_gallery_planning_guide.content',
    author: 'Meine Nieuwland',
    date: '2026-08-24',
    readingTime: 8,
    image: '/images/blog/gids-bruiloftsgalerij-plannen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'corporate_event_media_hub',
    source: 'soro',
    relatedContentPageIds: ['company_party', 'christmas', 'new_years_eve'],
    slug: 'blog.posts.corporate_event_media_hub.slug',
    title: 'blog.posts.corporate_event_media_hub.title',
    titleShort: 'blog.posts.corporate_event_media_hub.title_short',
    excerpt: 'blog.posts.corporate_event_media_hub.excerpt',
    content: 'blog.posts.corporate_event_media_hub.content',
    author: 'Meine Nieuwland',
    date: '2026-08-21',
    readingTime: 8,
    image: '/images/blog/bedrijfsevent-mediahub-inrichten-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'app_free_photo_sharing_experiences',
    source: 'soro',
    relatedContentPageIds: ['family_gatherings', 'birthday', 'wedding'],
    slug: 'blog.posts.app_free_photo_sharing_experiences.slug',
    title: 'blog.posts.app_free_photo_sharing_experiences.title',
    titleShort: 'blog.posts.app_free_photo_sharing_experiences.title_short',
    excerpt: 'blog.posts.app_free_photo_sharing_experiences.excerpt',
    content: 'blog.posts.app_free_photo_sharing_experiences.content',
    author: 'Meine Nieuwland',
    date: '2026-08-19',
    readingTime: 9,
    image: '/images/blog/ervaringen-met-appvrij-fotos-delen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'invite_guests_direct_link',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'company_party', 'birthday'],
    slug: 'blog.posts.invite_guests_direct_link.slug',
    title: 'blog.posts.invite_guests_direct_link.title',
    titleShort: 'blog.posts.invite_guests_direct_link.title_short',
    excerpt: 'blog.posts.invite_guests_direct_link.excerpt',
    content: 'blog.posts.invite_guests_direct_link.content',
    author: 'Martijn de Vries',
    date: '2026-08-17',
    readingTime: 8,
    image: '/images/blog/gasten-uitnodigen-met-directe-link-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'who_can_see_event_gallery',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.who_can_see_event_gallery.slug',
    title: 'blog.posts.who_can_see_event_gallery.title',
    titleShort: 'blog.posts.who_can_see_event_gallery.title_short',
    excerpt: 'blog.posts.who_can_see_event_gallery.excerpt',
    content: 'blog.posts.who_can_see_event_gallery.content',
    author: 'Meine Nieuwland',
    date: '2026-08-16',
    readingTime: 8,
    image: '/images/blog/wie-ziet-mijn-evenementgalerij-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'event_gallery_software',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'company_party', 'birthday'],
    slug: 'blog.posts.event_gallery_software.slug',
    title: 'blog.posts.event_gallery_software.title',
    titleShort: 'blog.posts.event_gallery_software.title_short',
    excerpt: 'blog.posts.event_gallery_software.excerpt',
    content: 'blog.posts.event_gallery_software.content',
    author: 'Meine Nieuwland',
    date: '2026-08-13',
    readingTime: 9,
    image: '/images/blog/eventgalerij-software-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'whatsapp_alternative_photo_sharing',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'company_party', 'birthday'],
    slug: 'blog.posts.whatsapp_alternative_photo_sharing.slug',
    title: 'blog.posts.whatsapp_alternative_photo_sharing.title',
    titleShort: 'blog.posts.whatsapp_alternative_photo_sharing.title_short',
    excerpt: 'blog.posts.whatsapp_alternative_photo_sharing.excerpt',
    content: 'blog.posts.whatsapp_alternative_photo_sharing.content',
    author: 'Martijn de Vries',
    date: '2026-08-11',
    readingTime: 8,
    image: '/images/blog/alternatief-voor-whatsapp-fotos-delen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'personal_message_photo_album',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary', 'birthday'],
    slug: 'blog.posts.personal_message_photo_album.slug',
    title: 'blog.posts.personal_message_photo_album.title',
    titleShort: 'blog.posts.personal_message_photo_album.title_short',
    excerpt: 'blog.posts.personal_message_photo_album.excerpt',
    content: 'blog.posts.personal_message_photo_album.content',
    author: 'Meine Nieuwland',
    date: '2026-08-10',
    readingTime: 9,
    image: '/images/blog/persoonlijke-boodschap-toevoegen-aan-fotoalbum-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'collect_guest_photos_party',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'birthday', 'company_party'],
    slug: 'blog.posts.collect_guest_photos_party.slug',
    title: 'blog.posts.collect_guest_photos_party.title',
    titleShort: 'blog.posts.collect_guest_photos_party.title_short',
    excerpt: 'blog.posts.collect_guest_photos_party.excerpt',
    content: 'blog.posts.collect_guest_photos_party.content',
    author: 'Martijn de Vries',
    date: '2026-08-09',
    readingTime: 9,
    image: '/images/blog/gasten-fotos-laten-uploaden-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'share_team_photos_sports_event',
    source: 'soro',
    relatedContentPageIds: ['sports_events', 'company_party'],
    slug: 'blog.posts.share_team_photos_sports_event.slug',
    title: 'blog.posts.share_team_photos_sports_event.title',
    titleShort: 'blog.posts.share_team_photos_sports_event.title_short',
    excerpt: 'blog.posts.share_team_photos_sports_event.excerpt',
    content: 'blog.posts.share_team_photos_sports_event.content',
    author: 'Meine Nieuwland',
    date: '2026-08-06',
    readingTime: 8,
    image: '/images/blog/teamfotos-delen-tijdens-een-sportevenement-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'collect_corporate_event_photos',
    source: 'soro',
    relatedContentPageIds: ['company_party', 'christmas', 'new_years_eve'],
    slug: 'blog.posts.collect_corporate_event_photos.slug',
    title: 'blog.posts.collect_corporate_event_photos.title',
    titleShort: 'blog.posts.collect_corporate_event_photos.title_short',
    excerpt: 'blog.posts.collect_corporate_event_photos.excerpt',
    content: 'blog.posts.collect_corporate_event_photos.content',
    author: 'Martijn de Vries',
    date: '2026-08-05',
    readingTime: 9,
    image: '/images/blog/fotos-verzamelen-bedrijfsevenement-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'anniversary_party_memories',
    source: 'soro',
    relatedContentPageIds: ['wedding_anniversary', 'family_gatherings'],
    slug: 'blog.posts.anniversary_party_memories.slug',
    title: 'blog.posts.anniversary_party_memories.title',
    titleShort: 'blog.posts.anniversary_party_memories.title_short',
    excerpt: 'blog.posts.anniversary_party_memories.excerpt',
    content: 'blog.posts.anniversary_party_memories.content',
    author: 'Meine Nieuwland',
    date: '2026-08-04',
    readingTime: 8,
    image: '/images/blog/herinneringen-verzamelen-op-jubileumfeest-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'collect_birthday_guest_photos',
    source: 'soro',
    relatedContentPageIds: ['birthday', 'family_gatherings'],
    slug: 'blog.posts.collect_birthday_guest_photos.slug',
    title: 'blog.posts.collect_birthday_guest_photos.title',
    titleShort: 'blog.posts.collect_birthday_guest_photos.title_short',
    excerpt: 'blog.posts.collect_birthday_guest_photos.excerpt',
    content: 'blog.posts.collect_birthday_guest_photos.content',
    author: 'Meine Nieuwland',
    date: '2026-08-03',
    readingTime: 8,
    image: '/images/blog/digitale-gastenfotos-verjaardag-verzamelen-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'live_wedding_slideshow',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary'],
    slug: 'blog.posts.live_wedding_slideshow.slug',
    title: 'blog.posts.live_wedding_slideshow.title',
    titleShort: 'blog.posts.live_wedding_slideshow.title_short',
    excerpt: 'blog.posts.live_wedding_slideshow.excerpt',
    content: 'blog.posts.live_wedding_slideshow.content',
    author: 'Meine Nieuwland',
    date: '2026-08-02',
    readingTime: 9,
    image: '/images/blog/live-diavoorstelling-voor-bruiloft-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'private_party_photo_album',
    source: 'soro',
    relatedContentPageIds: ['birthday', 'family_gatherings'],
    slug: 'blog.posts.private_party_photo_album.slug',
    title: 'blog.posts.private_party_photo_album.title',
    titleShort: 'blog.posts.private_party_photo_album.title_short',
    excerpt: 'blog.posts.private_party_photo_album.excerpt',
    content: 'blog.posts.private_party_photo_album.content',
    author: 'Meine Nieuwland',
    date: '2026-08-01',
    readingTime: 8,
    image: '/images/blog/prive-fotoalbum-voor-feest-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'event_photo_upload_no_app',
    source: 'soro',
    relatedContentPageIds: ['company_party', 'wedding'],
    slug: 'blog.posts.event_photo_upload_no_app.slug',
    title: 'blog.posts.event_photo_upload_no_app.title',
    titleShort: 'blog.posts.event_photo_upload_no_app.title_short',
    excerpt: 'blog.posts.event_photo_upload_no_app.excerpt',
    content: 'blog.posts.event_photo_upload_no_app.content',
    author: 'Martijn de Vries',
    date: '2026-07-31',
    readingTime: 9,
    image: '/images/blog/fotos-uploaden-evenement-zonder-app-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'qr_code_video_upload',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'sports_events'],
    slug: 'blog.posts.qr_code_video_upload.slug',
    title: 'blog.posts.qr_code_video_upload.title',
    titleShort: 'blog.posts.qr_code_video_upload.title_short',
    excerpt: 'blog.posts.qr_code_video_upload.excerpt',
    content: 'blog.posts.qr_code_video_upload.content',
    author: 'Meine Nieuwland',
    date: '2026-07-30',
    readingTime: 8,
    image: '/images/blog/videos-uploaden-via-qr-code-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'collect_wedding_guest_photos',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary'],
    slug: 'blog.posts.collect_wedding_guest_photos.slug',
    title: 'blog.posts.collect_wedding_guest_photos.title',
    titleShort: 'blog.posts.collect_wedding_guest_photos.title_short',
    excerpt: 'blog.posts.collect_wedding_guest_photos.excerpt',
    content: 'blog.posts.collect_wedding_guest_photos.content',
    author: 'Meine Nieuwland',
    date: '2026-07-29',
    readingTime: 8,
    image: '/images/blog/gastenfotos-verzamelen-bruiloft-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'wedding_photo_sharing_no_app',
    source: 'soro',
    relatedContentPageIds: ['wedding', 'wedding_anniversary'],
    slug: 'blog.posts.wedding_photo_sharing_no_app.slug',
    title: 'blog.posts.wedding_photo_sharing_no_app.title',
    titleShort: 'blog.posts.wedding_photo_sharing_no_app.title_short',
    excerpt: 'blog.posts.wedding_photo_sharing_no_app.excerpt',
    content: 'blog.posts.wedding_photo_sharing_no_app.content',
    author: 'Meine Nieuwland',
    date: '2026-07-28',
    readingTime: 6,
    image: '/images/blog/bruiloft-fotos-delen-zonder-app-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'qr_code_event_photo_sharing',
    source: 'soro',
    relatedContentPageIds: ['birthday', 'company_party', 'new_years_eve'],
    slug: 'blog.posts.qr_code_event_photo_sharing.slug',
    title: 'blog.posts.qr_code_event_photo_sharing.title',
    titleShort: 'blog.posts.qr_code_event_photo_sharing.title_short',
    excerpt: 'blog.posts.qr_code_event_photo_sharing.excerpt',
    content: 'blog.posts.qr_code_event_photo_sharing.content',
    author: 'Meine Nieuwland',
    date: '2026-07-27',
    // Merged in the QR-code creation, testing and scannability material
    dateModified: '2026-08-07',
    readingTime: 11,
    // Social/link preview only — not rendered inside the article body
    image: '/images/blog/fotos-delen-met-qr-code-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'event_albums_guide',
    relatedContentPageIds: ['wedding', 'vacation', 'company_party'],
    slug: 'blog.posts.event_albums_guide.slug',
    title: 'blog.posts.event_albums_guide.title',
    titleShort: 'blog.posts.event_albums_guide.title_short',
    excerpt: 'blog.posts.event_albums_guide.excerpt',
    content: 'blog.posts.event_albums_guide.content',
    author: 'Martijn de Vries',
    date: '2026-07-11',
    readingTime: 5,
    image: '/images/blog/evenementfotos-organiseren-met-albums-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'eu_data_security',
    relatedContentPageIds: ['company_party', 'wedding'],
    slug: 'blog.posts.eu_data_security.slug',
    title: 'blog.posts.eu_data_security.title',
    titleShort: 'blog.posts.eu_data_security.title_short',
    excerpt: 'blog.posts.eu_data_security.excerpt',
    content: 'blog.posts.eu_data_security.content',
    author: 'Meine Nieuwland',
    date: '2026-07-06',
    // HarfangLab statistic sourced: link, sample size and fieldwork period added
    dateModified: '2026-08-03',
    readingTime: 5,
    image: '/images/blog/zo-slaat-momentshare-je-eventfotos-veilig-op-in-de-eu-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'momentshare_app_announcement',
    relatedContentPageIds: ['vacation', 'family_gatherings'],
    slug: 'blog.posts.momentshare_app_announcement.slug',
    title: 'blog.posts.momentshare_app_announcement.title',
    titleShort: 'blog.posts.momentshare_app_announcement.title_short',
    excerpt: 'blog.posts.momentshare_app_announcement.excerpt',
    content: 'blog.posts.momentshare_app_announcement.content',
    author: 'Martijn de Vries',
    date: '2026-05-17',
    readingTime: 3,
    image: '/images/blog/momentshare-app-nu-beschikbaar-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
  {
    id: 'qr_code_photo_sharing_guide',
    relatedContentPageIds: ['wedding', 'company_party', 'birthday'],
    slug: 'blog.posts.qr_code_photo_sharing_guide.slug',
    title: 'blog.posts.qr_code_photo_sharing_guide.title',
    titleShort: 'blog.posts.qr_code_photo_sharing_guide.title_short',
    excerpt: 'blog.posts.qr_code_photo_sharing_guide.excerpt',
    content: 'blog.posts.qr_code_photo_sharing_guide.content',
    author: 'Meine Nieuwland',
    date: '2026-02-15',
    // Expanded from an 850-word explainer into the event photo sharing hub
    dateModified: '2026-08-03',
    readingTime: 9,
    image: '/images/blog/qr-code-fotos-delen-complete-gids-2026.webp',
    imageWidth: 1536,
    imageHeight: 1024,
  },
]
